import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import AuthModal from "./AuthModal";
import MobileNav from "./MobileNav";
import Footer from "./Footer";
import PriceTicker from "./PriceTicker";
import BigWinWatcher from "./BigWinWatcher";
import AssistantWidget from "./AssistantWidget";

export default function Layout() {
  const [authOpen, setAuthOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("fmi_sidebar") === "collapsed");
  const loc = useLocation();
  const isGame = loc.pathname.startsWith("/games/");

  const toggle = () => {
    setCollapsed((c) => {
      localStorage.setItem("fmi_sidebar", c ? "expanded" : "collapsed");
      return !c;
    });
  };

  return (
    <div className="App min-h-screen flex noise">
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className={`flex-1 flex flex-col min-w-0 sidebar-offset ${collapsed ? "md:pl-[76px]" : "md:pl-[240px]"}`}>
        <Header onConnect={() => setAuthOpen(true)} />
        <PriceTicker />
        <main className="flex-1 px-4 md:px-8 pt-5 pb-28 md:pb-10">
          <Outlet context={{ openAuth: () => setAuthOpen(true) }} />
          {!isGame && <Footer />}
        </main>
      </div>
      <BigWinWatcher />
      <AssistantWidget />
      <MobileNav onConnect={() => setAuthOpen(true)} />
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
}
